import React, { useEffect, useState } from "react";
import { storage } from "../util/firebase";

export default function useImageUrl(ref) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!ref) {
      return;
    }
    storage
      .ref(ref)
      .getDownloadURL()
      .then((url) => {
        console.log(url);
        setUrl(url);
      })
      .catch((error) => {
        console.log(error);

        // Handle any errors
      });
  }, [ref]);
  return url;
}
